<template>
    <div class="dialog">
        <el-dialog title="驳回原因" :visible.sync="visible" :lock-scroll="true" width="818px" :before-close="handleClose">
            <el-form ref="form" :model="form" :inline="true" style="text-align: left" label-width="140px">
                <el-row class="reject-c">
                    <div class="title">

                    </div>
                    <el-input v-model.trim="form.checkOpinion" type="textarea" maxlength="200" show-word-limit clearable
                        size="small" style="width:100%" />
                </el-row>
            </el-form>
            <div class="btnBox">
                <el-button size="small" @click="handleClose">取消</el-button>
                <el-button type="primary" size="small" @click="reject">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { salesPosterInfoCheck } from "@/api/externalSalesRule";

export default {
    components: {

    },
    props: {
        btnType: {
            type: String,
            default: ''
        },
    },
    computed: {
        visible() {
            return this.dialogShow
        }
    },
    data() {
        return {
            showForm: false, //是否展示表单
            dialogShow: false,
            isDisabled: false, 
            form: {
                id:null
            },
            title: '',
        }
    },
    mounted() {

    },
    methods: {
        init(id) {
            this.title = '图文海报审核';
            this.isDisabled = true;
            this.dialogShow = true;
            this.form.id = id; 
            this.$forceUpdate();
        },
        reject() {
            let params = {
                "id": this.form.id,
                "checkStatus": 2, //审核状态(0:待审核 1：审核通过 2：驳回)
                "checkOpinion": this.form.checkOpinion //审核意见
            }
            salesPosterInfoCheck(params).then((res) => {
                if (res) {
                    this.$message.success('提交成功');
                    this.$emit('getList')
                    this.handleClose();
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        handleClose() {
            this.dialogShow = false; 
        }, 
    }
}
</script>
<style lang="scss">
.btnBox {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.serach {
    margin-bottom: 10px;
}

.goods-content {
    max-height: 70vh;
    overflow-y: auto;
}

.goodList {
    display: flex;
    justify-content: space-around;

    &:nth-child(3n) {
        margin-right: 0px;
    }

    .img-div {
        height: 88px;
        width: 88px;
        margin: 0 10px;

        image {
            width: 100%;
            height: 100%;
        }
    }

    .l {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
    }

    .r {
        width: 214px;
        display: flex;
        flex: 1;
        flex-direction: column;

        div {
            display: flex;
        }

        span {
            font-size: 13px;
            color: #333;
            //margin-top: 10px;
        }

        .name {
            text-align: left;
            font-size: 16px;
            font-weight: 600;
            color: var(--color-26);
        }

        .rr {
            text-align: left;
            color: var(--color-59);
            font-size: 14px;
        }
    }

    &:hover {
        //  border: 2px solid var(--main-color) !important;
    }
}

.reject-c {
    margin-top: 10px;

    .title {
        line-height: 30px;
    }
}</style>